<template>
  <b-card>
    <b-row class="mx-1 flex gap-2 items-center mb-3">
      <b-button
        variant="primary"
        size="sm"
        @click="$router.go(-1)"
      >
        <span class="k-arrow-left-2 text-white text-xl" />
      </b-button>
      <strong class="text-[20px] text-black font-semibold ml-1">
        Edit Biaya Ekspedisi {{ customListServices ? customListServices.shipping_name : '' }}
      </strong>
    </b-row>
    <div class="table-responsive">
      <BOverlay
        :show="loadingData"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        class="w-100"
        rounded="sm"
      >
        <table class="table table-hover">
          <TableHeaderExpeditionFee />
          <tbody v-if="!loadingData">
            <tr>
              <td>
                <div
                  class="d-flex justify-between"
                >
                  <div
                    class="d-flex gap-10"
                  >
                    <div class="w-14 bg-[#FFECE9] px-[7px] py-[3px] rounded-pill">
                      <img
                        :src="customListServices.image_logo"
                        alt=""
                      >
                    </div>
                    <div class="align-self-center">
                      {{ customListServices.shipping_name }}
                    </div>
                  </div>
                </div>
                <li
                  v-for="(services, index) in customListServices.services"
                  :key="index"
                  class="mb-[10px] w-[15rem] my-2"
                >
                  {{ services.service_name }}
                </li>
              </td>
              <td class="align-content-end text-center pt-3">
                <div
                  v-for="(services, index) in customListServices.services"
                  :key="index"
                  class="mb-[10px] w-75"
                >
                  <div
                    class="flex-grow-1"
                    style="min-width: 100px"
                  >
                    <b-input-group
                      append="%"
                    >
                      <b-form-input
                        v-model="services.cashback_from"
                        type="number"
                        @keypress="validateInput"
                      />
                    </b-input-group>
                  </div>
                </div>
              </td>
              <td class="align-content-end text-center">
                <div
                  v-for="(services, index) in customListServices.services"
                  :key="index"
                  class="mb-[10px] w-75"
                >
                  <div
                    class="flex-grow-1"
                    style="min-width: 100px"
                  >
                    <b-input-group
                      append="%"
                    >
                      <b-form-input
                        v-model="services.cod_fee_from"
                        type="number"
                        @keypress="validateInput"
                      />
                    </b-input-group>
                  </div>
                </div>
              </td>
              <td class="align-content-end text-center">
                <div
                  v-for="(services, index) in customListServices.services"
                  :key="index"
                  class="mb-[10px] w-75"
                >
                  <div
                    class="flex-grow-1"
                    style="min-width: 100px"
                  >
                    <b-input-group
                      append="%"
                    >
                      <b-form-input
                        v-model="services.cashback_to"
                        type="number"
                        @keypress="validateInput"
                      />
                    </b-input-group>
                  </div>
                </div>
              </td>
              <td class="align-content-end text-center">
                <div
                  v-for="(services, index) in customListServices.services"
                  :key="index"
                  class="mb-[10px] w-75"
                >
                  <div
                    class="flex-grow-1"
                    style="min-width: 100px"
                  >
                    <b-input-group
                      append="%"
                    >
                      <b-form-input
                        v-model="services.cashback_to_juragan"
                        type="number"
                        @keypress="validateInput"
                      />
                    </b-input-group>
                  </div>
                </div>
              </td>
              <td class="align-content-end text-center">
                <div
                  v-for="(services, index) in customListServices.services"
                  :key="index"
                  class="mb-[10px] w-75"
                >
                  <div
                    class="flex-grow-1"
                    style="min-width: 100px"
                  >
                    <b-input-group
                      append="%"
                    >
                      <b-form-input
                        v-model="services.cashback_to_saudagar"
                        type="number"
                        @keypress="validateInput"
                      />
                    </b-input-group>
                  </div>
                </div>
              </td>
              <td class="align-content-end text-center">
                <div
                  v-for="(services, index) in customListServices.services"
                  :key="index"
                  class="mb-[10px] w-75"
                >
                  <div
                    class="flex-grow-1"
                    style="min-width: 100px"
                  >
                    <b-input-group
                      append="%"
                    >
                      <b-form-input
                        v-model="services.cod_fee_to"
                        type="number"
                        @keypress="validateInput"
                      />
                    </b-input-group>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </BOverlay>
    </div>
    <div class="W-full border-t-2 pt-1 pr-2 d-flex justify-end gap-10">
      <b-button
        :variant="isUnchanged ? 'outline-secondary' : 'outline-primary'"
        class="w-40"
        :disabled="isUnchanged"
        @click="resetCondition"
      >
        Reset
      </b-button>
      <b-button
        :variant="isUnchanged ? 'secondary' : 'primary'"
        class="w-40"
        :disabled="isUnchanged"
        @click="setChangeExpeditionFee"
      >
        Simpan
      </b-button>
    </div>

    <ModalChangeExpeditionFee
      :change-values="changeValues"
      :shipping-name="shippingName"
      @on-click-confirm-button="confirmChangeExpeditionFee"
    />

    <ModalPIN
      id="modal-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Verifikasi PIN"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Batal"
      @on-confirm-button="updateExpeditionFee"
    />
  </b-card>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import { isNumber } from '@/libs/helpers'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import TableHeaderExpeditionFee from './component/TableHeaderExpeditionFee.vue'
import ModalChangeExpeditionFee from './component/ModalChangeExpeditionFee.vue'

export default {
  components: { TableHeaderExpeditionFee, ModalChangeExpeditionFee, ModalPIN },
  data() {
    return {
      isNumber,
      loadingData: true,
      defaultListServices: null,
      customListServices: null,
      changeValues: [],
      shippingName: '',
    }
  },
  computed: {
    isUnchanged() {
      return isEqual(this.defaultListServices, this.customListServices)
    },
  },
  mounted() {
    this.resetCondition()
  },
  methods: {
    setChangeExpeditionFee() {
      const changes = []
      const fields = [
        'cashback_from',
        'cod_fee_from',
        'cashback_to',
        'cashback_to_juragan',
        'cashback_to_saudagar',
        'cod_fee_to',
      ]

      this.customListServices.services.forEach((srv, i) => {
        const orig = this.defaultListServices.services[i]
        const diff = {}

        fields.forEach(field => {
          diff[`${field}_old`] = Number(orig[field])
          diff[`${field}_new`] = Number(srv[field])
        })

        changes.push({
          id: srv.id,
          service_name: srv.service_name,
          is_changed: this.hasChanged(diff),
          ...diff,
        })
      })

      this.changeValues = changes
      this.$bvModal.show('modal-change-expedition-fee')
    },
    hasChanged(diff) {
      return Object.keys(diff).some(key => {
        if (key.endsWith('_new')) {
          const oldKey = key.replace('_new', '_old')
          return diff[key] !== diff[oldKey]
        }
        return false
      })
    },
    resetCondition() {
      const original = cloneDeep(this.$route.params)

      if (Object.keys(original).length === 0) this.$router.push('skema-ekspedisi')

      this.defaultListServices = original
      this.customListServices = cloneDeep(original)
      this.shippingName = this.defaultListServices.shipping_name
      this.changeValues = []
      this.loadingData = false
    },
    validateInput(evt) {
      const char = String.fromCharCode(evt.which ?? evt.keyCode)
      const input = evt.target.value + char

      // Izinkan: angka atau titik
      if (!/^\d*\.?\d*$/.test(input)) {
        evt.preventDefault()
        return false
      }

      // Cegah titik kedua
      if (char === '.' && evt.target.value.includes('.')) {
        evt.preventDefault()
        return false
      }

      // Cegah nilai lebih dari 100
      const value = parseFloat(input)
      if (!Number.isNaN(value) && value > 100) {
        evt.preventDefault()
        return false
      }

      return true
    },
    confirmChangeExpeditionFee() {
      this.$bvModal.hide('modal-change-expedition-fee')
      this.$bvModal.show('modal-pin')
    },
    updateExpeditionFee() {
      const url = `/komship/api/v1/admin/shipment/configure/cost/${encodeURIComponent(this.shippingName.toLowerCase())}`

      const params = this.changeValues
        .filter(item => item.is_changed)
        .map(item => ({
          id: item.id,
          service_name: item.service_name,
          cashback_from: item.cashback_from_new,
          cod_fee_from: item.cod_fee_from_new,
          cashback_to: item.cashback_to_new,
          cashback_to_juragan: item.cashback_to_juragan_new,
          cashback_to_saudagar: item.cashback_to_saudagar_new,
          cod_fee_to: item.cod_fee_to_new,
          source: 'komship',
        }))

      this.$http_new.put(url, params)
        .then(res => {
          this.$bvModal.hide('modal-pin')
          this.$router.push({ name: 'skema-ekspedisi' })
        })
        .catch(res => {
          this.$toast_error({ message: 'Gagal Melakukan Perubahan Biaya Ekspedisi' })
        })
    },
  },
}
</script>
